export default __webpack_public_path__ + "static/award-02-69a2bcc039542de0d9052ea21e39e2af.png";